<template>
  <div
    :class="[
      'absolute z-10 left-0 top-header-main-desktop mobile+tablet:hidden w-full h-screen transform',
    ]"
  >
    <div
      :class="['z--1 absolute inset-0 bg-grey-800 opacity-70 cursor-pointer']"
      @click="closeDesktopMegamenu(true)"
    ></div>

    <div
      :class="['absolute z-10 top-0 left-0 bg-white pt-4 pb-22.5 w-full']"
      @mouseover="openDesktopMegamenu(navItem.id)"
      @mouseleave="closeDesktopMegamenu(false)"
    >
      <div class="o-wrapper">
        <div
          :class="['text-md leading-base content mb-4 text-heading font-bold']"
          v-html="navItem.heading"
          v-if="navItem.heading"
        ></div>

        <div class="flex items-start">
          <div
            v-for="(navChildItem, navChildItemIndex) in navItem.children"
            :class="['lg:w-[232px]', navChildItemIndex === 0 ? '' : 'lg:ml-7']"
            :key="navChildItem.id"
          >
            <div
              class="mb-3.5 w-4/5"
              v-if="
                navChildItem.transformedImages !== null ||
                navChildItem.svgImage !== null
              "
            >
              <div class="aspect-w-4 aspect-h-3">
                <picture v-if="navChildItem.transformedImages !== null">
                  <source
                    :data-srcset="navChildItem.transformedImages[0].url"
                    type="image/webp"
                  />
                  <source
                    :data-srcset="navChildItem.transformedImages[1].url"
                    type="image/jpeg"
                  />
                  <img
                    class="w-full h-full object-center object-cover"
                    :src="navChildItem.transformedImages[1].url"
                    :alt="navChildItem.transformedImages[1].title"
                  />
                </picture>
                <img
                  v-lazy
                  v-if="navChildItem.svgImage !== null"
                  :src="navChildItem.svgImage.url"
                  :alt="navChildItem.svgImage.title"
                  class="w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <ul class="text-none list-none">
              <li class="mb-3.5">
                <a
                  :href="navChildItem.url"
                  :target="navChildItem.newWindow ? '_blank' : '_self'"
                  :class="[
                    'group relative focus:outline-none text-heading',
                    navChildItem.headerNavType
                      ? 'inline-flex flex-nowrap font-semibold items-center u-body-md rounded-lg h-12 px-2 xs:px-4 py-3 border border-solid border-primary hover:shadow-button-secondary transition duration-200 ease-in-out'
                      : 'inline-block font-bold  u-body-lg',
                    navChildItem.classes,
                    {
                      'cursor-default': !navChildItem.url,
                    },
                  ]"
                  @focus="openDesktopMegamenu(navItem.id)"
                  @blur="closeDesktopMegamenu(false)"
                >
                  <span
                    :class="[
                      'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                    ]"
                  ></span>
                  <span
                    :class="[
                      'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                    ]"
                  >
                    {{ navChildItem.title }}
                  </span>
                </a>
              </li>

              <template v-if="navChildItem.children">
                <li
                  v-for="(
                    navSubchildItem, navSubchildItemIndex
                  ) in navChildItem.children"
                  :class="navSubchildItemIndex === 0 ? '' : 'mt-2'"
                  :key="navSubchildItem.id"
                >
                  <a
                    :href="navSubchildItem.url"
                    :target="navSubchildItem.newWindow ? '_blank' : '_self'"
                    :class="[
                      'group relative focus:outline-none ',
                      navSubchildItem.headerNavType
                        ? 'inline-flex flex-nowrap text-heading font-semibold items-center u-body-md rounded-lg h-12 px-2 xs:px-4 py-3 border border-solid border-primary hover:shadow-button-secondary transition duration-200 ease-in-out'
                        : 'inline-block text-body u-body-lg',
                      navSubchildItem.classes,
                      {
                        'cursor-default': !navSubchildItem.url,
                      },
                    ]"
                    @focus="openDesktopMegamenu(navItem.id)"
                    @blur="closeDesktopMegamenu(false)"
                  >
                    <span
                      :class="[
                        'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                      ]"
                    ></span>
                    <span
                      :class="[
                        'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                      ]"
                    >
                      {{ navSubchildItem.title }}
                    </span>
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueLazyDirective from '../../../directives/v-lazy';

export default {
  directives: {
    lazy: VueLazyDirective,
  },
  props: {
    navItem: {
      type: Object,
      required: true,
    },
    closeDesktopMegamenu: {
      type: Function,
      required: true,
    },
    openDesktopMegamenu: {
      type: Function,
      required: true,
    },
  },
};
</script>
